"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiClient = void 0;
const ferrum_plumbing_1 = require("ferrum-plumbing");
const AppState_1 = require("../store/AppState");
const cross_fetch_1 = __importDefault(require("cross-fetch"));
const types_1 = require("types");
class ApiClient {
    constructor(baseUrl, client) {
        this.baseUrl = baseUrl;
        this.client = client;
        this.jwtToken = '';
        this.address = '';
        this.network = '';
    }
    __name__() { return 'ApiClient'; }
    async signInToServer(userProfile) {
        ferrum_plumbing_1.ValidationUtils.isTrue(!!userProfile, '"userProfile" must be provided');
        const address = AppState_1.addressForUser(userProfile);
        ferrum_plumbing_1.ValidationUtils.isTrue(!!address, 'User must have a valid "address"');
        const userAddress = address.address;
        const network = address.network;
        const res = await this.api({
            command: 'signInUsingAddress', data: { userAddress }, params: []
        });
        const { unsecureSession } = res;
        if (!unsecureSession) {
            throw new Error('Could not connect to backend');
        }
        this.address = userAddress;
        this.network = network;
        this.jwtToken = unsecureSession;
        return res;
    }
    async authenticateAddress(address) {
        ferrum_plumbing_1.ValidationUtils.isTrue(!!address, '"signature" must be provided');
        const res = await this.api({
            command: 'authenticateAddress', data: { address }, params: []
        });
        return res;
    }
    async verifySignature(signature, info) {
        ferrum_plumbing_1.ValidationUtils.isTrue(!!signature, '"signature" must be provided');
        ferrum_plumbing_1.ValidationUtils.isTrue(!!info.address, '"signature" must be provided');
        console.log(signature, info.address, 'addressss');
        const res = await this.api({
            command: 'verifySignature', data: { signature, info }, params: []
        });
        console.log(res, 'verified');
        return res;
    }
    getNetwork() { return this.network; }
    getAddress() { return this.address; }
    async getUserEvents(application) {
        ferrum_plumbing_1.ValidationUtils.isTrue(!!this.getAddress(), 'must be signed in');
        ferrum_plumbing_1.ValidationUtils.isTrue(!!application, 'application must be provided');
        const res = await this.api({
            command: 'getUserEvents', data: { userAddress: this.getAddress(), application }, params: []
        });
        return res;
    }
    async updateChainEvents(eventType, events) {
        ferrum_plumbing_1.ValidationUtils.isTrue(!!this.getAddress(), 'must be signed in');
        const res = await this.api({
            command: 'updateChainEvents', data: { eventType, events }, params: []
        });
        return res;
    }
    async updateChainEvent(event) {
        ferrum_plumbing_1.ValidationUtils.isTrue(!!this.getAddress(), 'must be signed in');
        const res = await this.api({
            command: 'updateChainEvent', data: { event }, params: []
        });
        return res;
    }
    async loadHttpProviders() {
        let providers = (await this.api({
            command: 'getHttpProviders', data: {},
            params: []
        }));
        if (!providers) {
            throw new Error('getHttpProviders returned empty');
        }
        return providers;
    }
    async getContractAllocation(userAddress, contractAddress, currency) {
        return this.api({
            command: 'getContractAllocation', data: { userAddress, contractAddress, currency },
            params: []
        });
    }
    async setContractAllocation(userAddress, contractAddress, currency, amount) {
        const requests = await this.api({
            command: 'approveAllocationGetTransaction',
            data: { currency, amount: amount || '1', userAddress, contractAddress }, params: []
        });
        ferrum_plumbing_1.ValidationUtils.isTrue(!!requests && !!requests.length, 'Error calling approve. No requests');
        console.log('About to submit request', { requests });
        const requestId = await this.client.sendTransactionAsync(this.network, requests, { currency, amount, userAddress, contractAddress });
        ferrum_plumbing_1.ValidationUtils.isTrue(!!requestId, 'Could not submit transaction.');
        return requestId.split('|')[0]; // Convert the requestId to transction Id. TODO: Do this a better way
    }
    async tokenList() {
        try {
            return await this.api({ command: 'tokenList', data: {}, params: [] });
        }
        catch (e) {
            console.error('Error getting tokenList ', e);
            return [];
        }
    }
    async api(req) {
        try {
            const res = await cross_fetch_1.default(this.baseUrl, {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(req),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.jwtToken}`
                },
            });
            const resText = await res.text();
            if (Math.round(res.status / 100) === 2) {
                return resText ? JSON.parse(resText) : undefined;
            }
            const error = resText;
            let jerror;
            try {
                jerror = JSON.parse(error);
            }
            catch (e) { }
            types_1.logError('Server returned an error when calling ' + req + JSON.stringify({
                status: res.status, statusText: res.statusText, error
            }), new Error());
            throw new Error((jerror === null || jerror === void 0 ? void 0 : jerror.error) ? jerror.error : error);
        }
        catch (e) {
            types_1.logError('Error calling api with ' + JSON.stringify(req), e);
            throw e;
        }
    }
    async runServerTransaction(fun) {
        ferrum_plumbing_1.ValidationUtils.isTrue(!!this.network, 'Not commected to a network');
        const res = await fun();
        console.log('RES ISO', res);
        ferrum_plumbing_1.ValidationUtils.isTrue(!!res, 'Error calling deposit. No requests');
        const requestId = await this.client.sendTransactionAsync(this.network, [res], {});
        ferrum_plumbing_1.ValidationUtils.isTrue(!!requestId, 'Could not submit transaction.');
        const txId = requestId.split('|')[0];
        console.log('Deposit generated tx id ', txId);
        return txId;
    }
}
exports.ApiClient = ApiClient;
//# sourceMappingURL=ApiClient.js.map